export default function LoadingScreen() {
  return (
    <div className="loading-screen">
      <div className="loading-screen-text">The Belonging Co | Conference 2026</div>
    </div>
  );
}
